angular.module('bb.my_business').config(myBusinessRoutes);

myBusinessRoutes.$inject = ['$routeProvider'];

function myBusinessRoutes($routeProvider) {
  $routeProvider
    .when('/my_business/action_required', {
      template: '<action-required-detail />',
    })

    .when('/my_business/appointments', {
      template: '<appointments-page />',
    })

    .when('/my_business/appointment/:appointmentId', {
      template: '<manage-appointment-page />',
    })
    .when('/my_business/virtual_tour/:tourId', {
      template: '<bb-virtual-tour-details is-my-business="true" />',
    })

    .when('/my_business/appointment/:appointmentId/cancel', {
      template: '<coop-cancel-appointment-page />',
    })

    .when('/my_business/appointment/:appointmentId/time_change', {
      template: '<bb-internal-coop-time-change />',
    })

    .when('/my_business/appointment/:appointmentId/feedback', {
      template: '<bb-internal-feedback />',
    });
}

export {};
